/** @format */
import * as Yup from 'yup';

import { baseApiUrl } from './helper';

export const defaultPasswordPolicy = {
  strict: false,
  min_length: 8,
  max_length: 64,
  check_compromised: false,
  expiry_enabled: false,
  expiry_months: 1,
};

export async function fetchPasswordPolicy() {
  try {
    const res = await fetch(`${baseApiUrl()}/general/password-policy`);
    if (!res.ok) {
      return defaultPasswordPolicy;
    }
    const data = await res.json();
    return { ...defaultPasswordPolicy, ...data };
  } catch {
    return defaultPasswordPolicy;
  }
}

/**
 * New / reset password field (matches backend when strict + min/max align).
 * Login uses {@link buildLoginPasswordFieldSchema} — no min length.
 */
export function buildNewPasswordFieldSchema(policy) {
  let schema = Yup.string()
    .required('کلمه عبور نمی‌تواند خالی باشد')
    .min(
      policy.min_length,
      `کلمه عبور نمی‌تواند کمتر از ${policy.min_length} کاراکتر باشد`,
    )
    .max(
      policy.max_length,
      `کلمه عبور نباید بیشتر از ${policy.max_length} کاراکتر باشد`,
    );

  if (policy.strict) {
    schema = schema.matches(
      new RegExp(
        `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\\-=\\[\\]{};':"\\\\|,.<>\\/?]).{${policy.min_length},}$`,
      ),
      'رمز عبور باید شامل حروف بزرگ و کوچک لاتین، عدد و یک علامت خاص باشد',
    );
  }

  return schema;
}

/** Login: never enforce min length (legacy passwords). */
export function buildLoginPasswordFieldSchema(policy) {
  return Yup.string()
    .required('کلمه عبور نمی‌تواند خالی باشد')
    .max(
      policy.max_length,
      `کلمه عبور نباید بیشتر از ${policy.max_length} کاراکتر باشد`,
    );
}

/** Admin user edit: empty password = leave unchanged. */
export function buildOptionalNewPasswordFieldSchema(policy) {
  return Yup.lazy((value) => {
    if (value === undefined || value === null || value === '') {
      return Yup.string().nullable();
    }

    return buildNewPasswordFieldSchema(policy);
  });
}
